import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/user'

// The one brand list. A brand is a folder key: packages/end-users/.../brand/<brand>,
// packages/ui-components/.../components/<brand>, packages/server/.../generate/brand/<brand>.
export const BrandSchema = z.enum(['default', 'bmw'])

export enum Brand {
  default = 'default',
  bmw = 'bmw',
}

// reason: a brand whose own email template supplies the logo makes the campaign
// logo and the email image optional (online.schema.ts). This is an email-template
// fact, not a screen fact: the end-user theme's logo paints screens only, while
// campaign.logo fills {{logo}} in the mail and prints on the postcard back.
// Register the brand here, do not compare literals.
export const BRANDS_WITH_FIXED_LOGO: ReadonlySet<Brand> = new Set([Brand.bmw])

export const brandHasFixedLogo = (brand?: string | null): boolean =>
  BRANDS_WITH_FIXED_LOGO.has(brand as Brand)

const CustomerSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    brand: BrandSchema.optional().nullable(),
  })
  .passthrough()

const UserSchema = z
  .object({
    id: z.string(),
    email: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
    role: z.string().optional().nullable(),
    customerId: z.string().optional().nullable(),
    customer: CustomerSchema.optional().nullable(),
  })
  .passthrough()

// Contract
export const user = c.router({
  getMe: {
    method: 'GET',
    path: `${prefix}/me`,
    responses: {
      200: UserSchema,
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Get current authenticated user',
  },
})
